import { useState, useEffect } from "react";
import { Modal, Button, TextField, Box } from "@mui/material";
import AuthService from "services/auth-service";
import { useMaterialUIController, toggleReloadWallets } from "context";

const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
};

const SaveModal = ({ open, handleClose, wallet }) => {
    const [, dispatch] = useMaterialUIController();

    const [formData, setFormData] = useState({
        name: "",
    });

    useEffect(() => {
        setFormData({
            name: wallet ? wallet.name : "",
        });
    }, [wallet]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async () => {
        wallet ? await AuthService.updateWallet(wallet.id, formData) : await AuthService.createWallet(formData);
        toggleReloadWallets(dispatch, Date.now());
        handleClose();
    };

    const handleDelete = async () => {
        await AuthService.deleteWallet(wallet.id);
        toggleReloadWallets(dispatch, Date.now());
        handleClose();
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <Box sx={modalStyle}>
                <h2>{wallet ? "Edit Wallet" : "Create Wallet"}</h2>
                <TextField
                    label="Name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    fullWidth
                    margin="normal"
                    type="text"
                />

                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Button disabled={!wallet} onClick={handleDelete} sx={{ mr: 2, backgroundColor: "red" }} variant="gradient" color="error">
                        Delete
                    </Button>
                    <Button onClick={handleClose} sx={{ mr: 2 }}>
                        Cancel
                    </Button>
                    <Button onClick={handleSubmit} variant="contained" color="info">
                        {wallet ? "Update" : "Create"}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default SaveModal;
